import * as React from 'react';
import './Collaborators.css';
import IBC_Logo from '../../assets/IBCLogo.svg';
import ciencia_Logo from '../../assets/cienciaLogo.svg';
import Planetario_Logo from '../../assets/PlanetarioLogo.svg';
import Institutions from './Institutions/Institutions.js';
import { useContext } from 'react';
import { TextReaderContext } from '../../context/TextReaderContext';

function Collaborators(){
    const { isTextReaderEnabled } = useContext(TextReaderContext);

    const handleTextRead = (text) => {
        if (isTextReaderEnabled) {
            window.speechSynthesis.cancel();
            const utterance = new SpeechSynthesisUtterance(text);
            utterance.lang = "pt-BR";
            window.speechSynthesis.speak(utterance);
        }
    };

    return (
        <section id="colaboradores" aria-label="Parcerias" className='collaborators-wrapper'>
            <div className="collaborators-container">
                <h2
                    className='collaborators-title section-title'
                    onClick={(e) => handleTextRead(e.currentTarget.textContent)}
                    onMouseEnter={(e) => handleTextRead(e.currentTarget.textContent)}
                >
                   Parcerias
                </h2>
            </div>
            <div className='institutions-wrapper'>
                <Institutions
                    image={IBC_Logo}
                    name='Instituto Benjamin Constant'
                    link="https://www.gov.br/ibc/pt-br"
                />
                <Institutions
                    image={ciencia_Logo}
                    name='Ciência ao Alcance das Mãos'
                    link="https://www.instagram.com/cienciaaoalcancedasmaos/"
                />
                <Institutions
                    image={Planetario_Logo}
                    name='Espaço Nave - Planetário de Maricá'
                    link="https://www.instagram.com/casadaciencia.planetario/"
                />
            </div>    
        </section>
    )
}

export default Collaborators;